import { routes as cotacao } from './cotacao';
import { routes as medicao } from './medicao';

const materials = [
  { key: 'bloco', description: 'Bloco' },
  { key: 'graute', description: 'Graute' },
  { key: 'argamassa', description: 'Argamassa' },
  { key: 'concreto', description: 'Concreto' },
  { key: 'ceramica', description: 'Cerâmica' },
  { key: 'cabos', description: 'Cabos' }
];

const materialChildren = materials.map((material) => ({
  path: material.key,
  description: material.description,
  goesToMenu: false,
  children: [...(cotacao[material.key] ?? []), ...(medicao[material.key] ?? [])]
}));

export default [
  {
    path: '/financeiro',
    name: 'financeiro',
    description: 'Financeiro',
    icon: 'uil-dollar-alt',
    children: materialChildren,
    customChildren: materials.map((material) => material.description)
  }
];

